import { render, staticRenderFns } from "./AcctNoSfx.vue?vue&type=template&id=0e4641d8&"
import script from "./AcctNoSfx.vue?vue&type=script&lang=js&"
export * from "./AcctNoSfx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports